<template>
    <article :id="`room-overview_${room.id}`">
        {{ $t('Room') }} :
        <b-link
                :to="{ name: 'projects.components.floors.rooms.show', params: { projectId, componentId, floorId, roomId: room.id } }"
        >
            {{ room.name }}
        </b-link>

        ( {{ $t('Height') }}: <span v-text="room.height ? `${room.height} m` : '---'" /> )
        ( {{ $t('Floor space') }}:
        <span v-html="room.floor_space ? `${room.floor_space} m<sup>2</sup>` : '---'" /> )

        <b-button
                :id="`room_${room.id}_popuper`"
                ref="button"
                :title="$t('Edit')"
                size="sm"
                variant="default"
        >
            <fa :title="$t('Edit')" icon="pen" />
        </b-button>

        <b-popover
                v-if="$gate.allow('update', room)"
                :container="`room-overview_${room.id}`"
                :target="`room_${room.id}_popuper`"
                boundary="window"
                placement="righttop"
                triggers="click blur"
        >
            <b-form
                    @keydown="form.onKeydown($event)"
                    @submit.prevent="handleSubmit"
            >
                <template slot="title">
                    <b-button :aria-label="$t('Close')" class="close" type="reset">
                        <span aria-hidden="true" class="d-inline-block">&times;</span>
                    </b-button>
                </template>

                <b-form-group
                        :invalid-feedback="form.errors.get('height')"
                        :label="$t('Height')"
                        :label-for="'room_' + room.id + 'height'"
                        :state="form.errors.has('height') ? false : null"
                        class="mb-1"
                        label-cols="4"
                >
                    <b-input-group size="sm">
                        <b-form-input
                                id="height"
                                v-model="form.height"
                                :readonly="$gate.deny('update', room)"
                                :state="form.errors.has('height') ? false : null"
                                min="0"
                                name="height"
                                step="0.001"
                                type="number"
                        />

                        <b-input-group-append is-text>
                            m
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

                <b-form-checkbox v-model="form.update_children">
                    {{ $t('Update walls height') }}
                </b-form-checkbox>


                <div class="text-right">
                    <b-button size="sm" type="submit" variant="primary">
                        {{ $t('Save') }}
                        <fa class="ml-1" icon="save" />
                    </b-button>
                </div>
            </b-form>
        </b-popover>

        <vertical-scroll>
          <room-walls
                  :component-id="componentId"
                  :floor-id="floorId"
                  :project-id="projectId"
                  :room-id="room.id"
                  :walls="room.walls"
                  class="mb-3"
          />
        </vertical-scroll>
    </article>
</template>
<script>
    import RoomWalls from '@/components/floors/RoomWalls'
    import Form from "vform";
    import VerticalScroll from "@/components/VerticalScroll";

    export default {
        name: 'FloorOverviewRoom',
        components: {VerticalScroll, RoomWalls},
        props: {
            componentId: {
                type: Number,
                required: true
            },
            floorId: {
                type: Number,
                required: true
            },
            projectId: {
                type: Number,
                required: true
            },
            room: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                form: new Form({
                    height: null,
                    update_children: false
                })
            }
        },

        computed: {
            apiUrl() {
                return `/api/projects/${this.projectId}/components/${this.componentId}/floors/${this.floorId}/rooms/${this.room.id}`;
            },
        },

        watch: {
            room: {
                handler(newValue) {
                    this.form.fill(newValue);
                },
                immediate: true
            }
        },

        methods: {
            handleSubmit() {
                this.form.put(this.apiUrl)
                    .catch(e => e.response || throw e)
                    .then(() => {
                        this.savedToast();
                        this.$emit('input', this.form.data())
                    })
            }
        }
    }
</script>